import styled, { css, keyframes } from 'styled-components';

export const DraggableItemStyled = styled.div<{ $isDragging: boolean; $disabled: boolean }>`
  border: ${({ $disabled, theme }) => ($disabled ? `1px solid ${theme.palette.grey[100]}` : '1px solid #e6e6e6')};
  background-color: ${({ $disabled, theme }) => ($disabled ? theme.palette.grey[100] : theme.palette.common.white)};
  color: ${({ $disabled, theme }) => ($disabled ? '#CDD0D5' : theme.palette.grey[700])};
  border-radius: 6px;
  margin: 8px 0;
  opacity: ${({ $disabled }) => ($disabled ? '0.5' : '1')};
  padding: 4px 6px;

  cursor: ${(props) => {
    if (props.$disabled) {
      return 'not-allowed';
    }
    return 'grab';
  }};

  p {
    margin: 0;
    padding: 0;
    overflow: hidden;
    color: ${({ theme }) => theme.palette.grey[700]};
    text-overflow: ellipsis;

    font-size: 12px;
    font-style: normal;
    font-weight: 500;
  }
`;

const pop = keyframes`
  0% {
    transform: scale(1);
    box-shadow:  0 0 0 1px ${({ theme }) => theme.palette.grey[200]},
    0 1px 3px 0 ${({ theme }) => theme.palette.grey[200]}
  }
  100% {
    transform: scale(1.1);
    box-shadow: 0 0 0 1px ${({ theme }) => theme.palette.grey[200]}, 0 1px 3px 0 ${({ theme }) =>
      theme.palette.grey[200]};
  }
`;

export const ItemStyled = styled.div<{
  $dragging: boolean;
  $disabled: boolean;
  $dragOverlay: boolean;
  $isLast: boolean;
}>`
  position: relative;
  display: flex;
  flex-grow: 1;
  align-items: center;
  padding: 6px;
  margin: 6px;
  margin-bottom: ${({ $isLast }) => ($isLast ? '6px' : '4px')};
  background-color: ${({ theme }) => theme.palette.common.white};
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  border-radius: 8px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.palette.grey[800]};
  cursor: grab;

  p {
    margin: 0;
    padding: 0;
    font-size: 12px;
    font-weight: 500;
    line-height: normal;
  }

  ${({ $dragging }) =>
    $dragging &&
    css`
      z-index: 0;
      border-radius: 8px;
      border: 1px solid ${({ theme }) => theme.palette.primary.main};
      background: ${({ theme }) => theme.palette.grey[100]};
      opacity: 0.5;
      cursor: grabbing;

      max-height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 250px;
    `}

  ${({ $disabled, theme }) =>
    $disabled &&
    css`
      color: ${theme.palette.grey[500]};
      background-color: ${theme.palette.grey[100]};
      cursor: not-allowed;
    `}

  ${({ $dragOverlay }) =>
    $dragOverlay &&
    css`
      cursor: inherit;
      animation: ${pop} 200ms cubic-bezier(0.18, 0.67, 0.6, 1.22);
      opacity: 1;
      border: 1px solid ${({ theme }) => theme.palette.primary.main};
      max-width: 250px;
      margin-right: 10px;
      cursor: grabbing;

      p {
        padding: 0;
        overflow: hidden;
        margin: 0 5px 0 5px;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    `}
`;

export const Actions = styled.span`
  display: flex;
  align-self: flex-start;
  margin-top: -12px;
  margin-left: auto;
  margin-bottom: -15px;
  margin-right: -10px;
`;

const fadeInAnimation = keyframes`
   0% {
     opacity: 0;
   }
   100% {
     opacity: 1;
   }
 `;

export const Wrapper = styled.li<{ $fadeIn: boolean; $dragOverlay: boolean }>`
  display: flex;
  box-sizing: border-box;
  transform: translate3d(0, 0, 0) scaleX(1) scaleY(1);
  transform-origin: 0 0;
  touch-action: manipulation;

  ${({ $fadeIn }) =>
    $fadeIn &&
    css`
      animation: ${fadeInAnimation} 500ms ease;
    `}

  ${({ $dragOverlay }) =>
    $dragOverlay &&
    css`
      --scale: 1.05;
      --box-shadow: 0 0 0 1px ${({ theme }) => theme.palette.grey[200]},
        0 1px 3px 0 ${({ theme }) => theme.palette.grey[200]};
      --box-shadow-picked-up: 0 0 0 1px ${({ theme }) => theme.palette.grey[200]},
        -1px 0 15px 0 ${({ theme }) => theme.palette.grey[200]},
        0px 15px 15px 0 ${({ theme }) => theme.palette.grey[400]};
      z-index: 999;
    `}
`;
